export function getImage(image) {
    return image && image.remoteUrl;
}
export function makeImageLinkFromId({ host, id, transform, }) {
    return [host, 'image/upload', transform, id].filter(Boolean).join('/');
}
export function makeImageLink({ host, image, transform, }) {
    const { id, remoteUrl } = image;
    if (!id) {
        return remoteUrl || '';
    }
    return [host, 'image/upload', transform, id].filter(Boolean).join('/');
}
//# sourceMappingURL=image.js.map